export const voterSelector = (state) => state.voter;